module.exports = __webpack_public_path__ + "img/slide1_1.60a87300.png";